var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherTableEditTableEraser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49896 15.0023H4.06002C3.64538 15.0025 3.24766 14.8379 2.95446 14.5447C2.66127 14.2515 2.49665 13.8538 2.49687 13.4391V4.06022C2.49665 3.64558 2.66127 3.24786 2.95446 2.95466C3.24766 2.66147 3.64538 2.49685 4.06002 2.49707H13.4389C13.8536 2.49685 14.2513 2.66147 14.5445 2.95466C14.8377 3.24786 15.0023 3.64558 15.0021 4.06022V7.49915",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74948 5.5817C8.72646 5.5817 8.7078 5.60036 8.7078 5.62338C8.7078 5.6464 8.72646 5.66507 8.74948 5.66507C8.7725 5.66507 8.79117 5.6464 8.79117 5.62338C8.79117 5.60036 8.7725 5.5817 8.74948 5.5817",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74948 11.8341C8.72646 11.8341 8.7078 11.8528 8.7078 11.8758C8.7078 11.8988 8.72646 11.9175 8.74948 11.9175C8.7725 11.9175 8.79117 11.8988 8.79117 11.8758C8.79117 11.8528 8.7725 11.8341 8.74948 11.8341",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74948 8.70816C8.72646 8.70816 8.7078 8.72683 8.7078 8.74985C8.7078 8.77287 8.72646 8.79153 8.74948 8.79153C8.7725 8.79153 8.79117 8.77287 8.79117 8.74985C8.79117 8.72683 8.7725 8.70816 8.74948 8.70816",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9175 8.74985C11.9175 8.72683 11.8988 8.70816 11.8758 8.70816C11.8528 8.70816 11.8341 8.72683 11.8341 8.74985C11.8341 8.77287 11.8528 8.79153 11.8758 8.79153C11.8988 8.79153 11.9175 8.77287 11.9175 8.74985",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66485 8.74985C5.66485 8.72683 5.64619 8.70816 5.62317 8.70816C5.60015 8.70816 5.58149 8.72683 5.58149 8.74985C5.58149 8.77287 5.60015 8.79153 5.62317 8.79153C5.64619 8.79153 5.66485 8.77287 5.66485 8.74985",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0609 17.5033H12.6928C12.9304 17.5032 13.1583 17.4087 13.3264 17.2407L17.2405 13.3266C17.5904 12.9763 17.5904 12.4088 17.2405 12.0586L15.7607 10.5779C15.4102 10.2279 14.8424 10.2279 14.4919 10.5779L10.2626 14.8072C9.91259 15.1577 9.91259 15.7255 10.2626 16.0761L11.4298 17.2432C11.5976 17.4097 11.8244 17.5032 12.0609 17.5033Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3135 12.7515L15.0646 15.5026",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6694 17.5033H12.501",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherTableEditTableEraser);
export default ForwardRef;